import {NativeDateAdapter} from "@angular/material/core";

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    return super.format(date, displayFormat);
  }

  override parse(value: any, parseFormat?: any): Date | null {
    if(typeof value === 'string') {
      let parts = value.split('.')
      if(parts.length == 3) {
        let tag = Number(parts[0])
        let monat = Number(parts[1])
        let jahr = Number(parts[2])
        if(!isNaN(tag) && !isNaN(monat) && !isNaN(jahr)) {
          if(jahr < 100) {
            jahr += 2000
          }
          return new Date(jahr, monat - 1, tag)
        }
      }
    }
    return super.parse(value, parseFormat);
  }
}
